import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { BottomModal } from '../shared/BottomModal';
import config from '../../config';
import { Button } from '../Button';

const formatTime = (ms) => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes} мин ${seconds} сек`;
};

export function LikeBanModal({ remainingMs = 600_000, onClose }) {
  const navigate = useNavigate();
  const [msLeft, setMsLeft] = useState(remainingMs);

  // Ref, чтобы смена onClose (inline-функция в родителе) не перезапускала таймер
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    setMsLeft(remainingMs);

    const startedAt = Date.now();
    const interval = setInterval(() => {
      const left = Math.max(0, remainingMs - (Date.now() - startedAt));
      setMsLeft(left);

      // Бан истёк — модалка больше не нужна
      if (left <= 0) {
        clearInterval(interval);
        onCloseRef.current?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingMs]);

  return createPortal(
    <BottomModal isOpen onClose={onClose} closeOnBackdrop>
      <div className="p-4 flex flex-col items-center text-white">
        <img className="size-[80px] mb-4" src="/icons/photo_overlay_button_4.svg" alt="like" />
        <p className="text-[22px] font-semibold mb-2 text-center">Слишком много лайков, будьте избирательнее!</p>
        <p className="text-base text-center mb-5">Новые станут доступны через:</p>
        <p className="bg-[#0B6666] px-3 py-2 rounded-lg tabular-nums">{formatTime(msLeft)}</p>

        <Button type="button" className='w-full my-10' onClick={() => navigate(config.ROUTES.PREMIUM)}>
          Хочу лайкать без ограничений
        </Button>
      </div>
    </BottomModal>,
    document.getElementById('root')
  );
}
